module.exports = __webpack_public_path__ + "media/images/official/about_yamori_kumamotohigashia-5508438e8e9874c2d433eeaf97335cdc.png";